export var ContentType;
(function (ContentType) {
    ContentType["JSON"] = "application/json";
    ContentType["OCTET_STREAM"] = "application/octet-stream";
})(ContentType || (ContentType = {}));
